import React from "react";

import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/team/PageHeader";

import img1 from "../../logos/photos/IMG-20250624-WA0005.jpg"
import MyPDF2 from "../../logos/photos/DOD2024.pdf"





export default function Slovak() {

  
  return (
    <Layout>
      <Navbar  />
      <PageHeader />
      <section id="about" className="about-us ptb-100 gray-light-bg">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-7">
              <div className="about-content-left section-heading">
                <h3 style={{color:'#e95d04'}}>
               Pantheon Featured at Slovak Horizon Event on Cluster 3 Calls
                                 </h3>
                <p>
               On 6 June 2024, the Slovak Horizon National Office held an online event titled “Presentation of
New Calls from the 2024 Work Programme – Cluster 3”, focusing on upcoming Horizon Europe
opportunities in the field of security research.
</p>
<p>
The session, led by the National Contact Point for Cluster 3, introduced the planned calls under
Civil Security for Society, alongside insights into support services offered by the Horizon Office.
Participants also had the chance to explore successful projects, including PANTHEON, which
was presented by our partner <a href='https://www.isemi.sk/en_GB/'>ISEMI</a>.</p>

<p>
The event attracted universities, research centres, public institutions, industry, and non-profits
interested in Horizon Europe Cluster 3 calls.</p>


              </div>
            </div>
            <div className="col-md-5">
              <div className="about-content-right">
                <img
                  src={img1}
                  style={{borderRadius:'10px'}}
                  alt="about us"
                  className="img-fluid"
                />

              </div>
            </div>
          </div>
        </div>
      </section>
  

      <Footer space />
    </Layout>
  );
}
